"use client";

import { useRef } from "react";
import { usePathname } from "next/navigation";
import AutocompleteSearch, { type SearchBoxRef } from "@/components/AutocompleteSearch";
import styles from "./styles.module.scss";
import { Box as MantineBox } from "@mantine/core";

const NavbarSearch = () => {
  const searchRef = useRef<SearchBoxRef>(null);
  const pathname = usePathname();
  // /appraise has its own image upload + crop flow feeding the appraisal form —
  // the navbar's own image search (paste/crop → navigates to /search) sits
  // right above it and is easy to hit by mistake, silently sending the user
  // to a real image search instead of adding the image to the appraisal.
  // Same mechanism MobileNavBarSearch already uses to hide this on /search.
  const isAppraisePage = pathname?.startsWith("/appraise");

  return (
    <MantineBox className={styles.navbarSearch} data-hide-imagesearch={isAppraisePage || undefined}>
      <AutocompleteSearch
        ref={searchRef}
        useTypewriter={false}
        navigateOnDropdownSelect={true}
        navigateOnSelect={false}
        compactMode={true}
        disableImageSearch={isAppraisePage}
      />
    </MantineBox>
  );
};

export default NavbarSearch;
